import { types } from 'mobx-state-tree';


const BATHROOM_TYPES = {
    ONE: 'one',
    ONE_AND_A_HALF: 'one-half',
    TWO: 'two',
    TWO_AND_A_HALF: 'two-half',
    THREE: 'three',
    THREE_AND_A_HALF: 'three-half',
    FOUR: 'four',
    FOUR_AND_A_HALF: 'four-half',
};

const BathroomTypeEnum = types.enumeration('BathroomType', Object.values(BATHROOM_TYPES));

export {
    BathroomTypeEnum,
};
export default BATHROOM_TYPES;
